import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import qs from 'qs';
import Modal from 'react-modal';

import OPDForm from './OPDForm';
import { getUserLink, postCancelOPD, postOPD } from '../actions';
import { codes, languages, defaultCode } from '../constants/countries';
import getHTML, { getTestHTML } from '../utils/html';
import { errorHandler } from '../utils/errorHandler';
import { changeLocale, configLocales } from '../utils/i18n';
import CancelOpdModal from './CancelOpdModal';

const isTest = process.env.NODE_ENV === 'development';

Modal.setAppElement('#root');

class OPD extends Component {
    static propTypes = {
        postOPD: PropTypes.object
    };

    constructor(props) {
        super(props)

        const params = qs.parse(prop('search', this.props.location), { ignoreQueryPrefix: true });

        const country = codes[defaultCode];
        const language = languages[country] && languages[country][0];

        this.state = {
            params,
            opdCountryCode: defaultCode,
            country,
            language,
            languages: languages[country],
            cancelModalOpened: false
        };
    }

    componentDidMount() {
        window.getHTML = getHTML;
        window.getTestHTML = getTestHTML;
        this.changeLanguage(this.state.language)
    }

    changeLanguage = language => {
        this.setState({ language });
        changeLocale(language);
    }

    onSubmit = values => {
        this.props.postOPD.dispatch({
            ...values,
            authkey: this.state.params.authKey,
            param1: this.state.params.par1,
            SoglasieTRANS: true,
            attachments: [{
                docType: 'opd',
                fileType: 'html',
                body: getHTML()
            }]
        });
    }

    onSubmitCancel = form => {
        this.props.postCancelOPD.dispatch({
            ...form.values,
            authkey: this.state.params.authKey,
            param1: this.state.params.par1
        });
    }

    setCountry = opdCountryCode => {
        const country = codes[opdCountryCode] || null;

        this.setState({
            opdCountryCode,
            country
        });
    }

    closeCancelModal = () => this.setState({ cancelModalOpened: false });

    openCancelModal = () => this.setState({ cancelModalOpened: true });

    render() {
        const { getUserLink, postCancelOPD } = this.props;
        const { meta } = this.props.postOPD;
        const { authKey, success, test = isTest, cancelled } = this.state.params;

        return (postCancelOPD.meta.success || cancelled) ? (
            <div className="cancelled">
                <h3>{this.props.t('cancelledSuccess')}</h3>
            </div>
        ) : (meta.success || success) ? (
            <div className="success">
                <h3>{this.props.t('success')}</h3>
            </div>
        ) : this.state.country && authKey || (test && this.state.country) ? (
            <ConfigProvider locale={configLocales[this.state.language]}>
                <div>
                    <CancelOpdModal
                        isOpen={this.state.cancelModalOpened}
                        onRequestClose={this.closeCancelModal}
                        t={this.props.t}
                        language={this.state.language}
                        onSubmit={this.onSubmitCancel}
                        metaPost={this.props.postCancelOPD.meta} />
                    <OPDForm
                        onSubmit={this.onSubmit}
                        authKey={authKey}
                        opdCountryCode={this.state.opdCountryCode}
                        setCountry={this.setCountry}
                        language={this.state.language}
                        languages={this.state.languages}
                        country={this.state.country}
                        changeLanguage={this.changeLanguage}
                        isTestForm={!!test}
                        getUserLink={getUserLink}
                        getRef={(props, values) => {
                            this.formState = props;
                            this.formValues = values;
                        }}
                        metaPost={this.props.postOPD.meta}
                        openCancelModal={this.openCancelModal}
                        t={this.props.t}
                    />
                </div>
            </ConfigProvider>
        ) : (
            <div>{this.props.t('nomatch')}</div>
        );
    }
}

export default withTranslation()(withRouter(withAsyncActions({
    getUserLink: getUserLink
        .withPayload(({ location }) => {
            const params = qs.parse(prop('search', location), { ignoreQueryPrefix: true });

            return params;
        })
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true }),
    postOPD: postOPD
        .withOptions({ resetOnUnmount: true })
        .withSuccessHandler(({ history, location }) => history.replace({
            pathname: location.pathname,
            search: '?success=true'
        }))
        .withErrorHandler(({ postOPD: { meta }, t }) => errorHandler(meta, t('error'), t)),
    postCancelOPD: postCancelOPD
        .withOptions({ resetOnUnmount: true })
        .withSuccessHandler(({ history, location }) => history.replace({
            pathname: location.pathname,
            search: '?=true'
        }))
        .withErrorHandler(({ postCancelOPD: { meta }, t }) => errorHandler(meta, t('cancelledError'), t))
})(OPD)));
